import React from "react";
import styling from "./AddSuppliers.module.css";
function AddSuppliers() {
  return (
    <div className={styling.AddSuppliers}>
      <h1>Suppliers</h1>
    </div>
  );
}

export default AddSuppliers;
